export default __webpack_public_path__ + "static/radoslawrybak-74ddf486ed1571a519258ddbb1c953f6.webp";